var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('transfer-page'):_c('legacy-main')
}
var staticRenderFns = []

export { render, staticRenderFns }